import React from "react";
import moment from "moment";
import numeral from "numeral";
import { FormattedMessage } from "react-intl";

const DisposalDrawerLogsDetails = ({filteredLogs}) => {
  return (
    <div style={{
      marginTop: "40px",
      display: "flex",
      flexDirection: "column"
    }}>
      <span style={{marginLeft: "8px", fontSize: "16px", fontWeight: "bold", color: "#152935"}}>
        <FormattedMessage id="preCog.assetsTab.drawer.logs.disposalDocInfoTitle" />
      </span>
      <span className="precog-assets-drawer-logs-sub-title">
        <FormattedMessage id="preCog.assetsTab.drawer.logs.docOpsInfoTitle" />
      </span>
      <div style={{display: "flex", flexWrap: "wrap"}}>
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.disposalDate" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.date === null ? "XXXXXXX" : moment(filteredLogs[0]?.date).format("DD/MM/YYYY")}</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.disposalPercentage" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.rate === null ? "0 %": `${filteredLogs[0]?.rate} %`}</p>
        </div>
        {filteredLogs[0]?.capital !== 0 && <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            {(filteredLogs[0]?.capital > 0 && filteredLogs[0]?.trackType === "STATUTORY") && <FormattedMessage id="preCog.assetsTab.drawer.logs.capitalGainStatutory" />}
            {(filteredLogs[0]?.capital < 0 && filteredLogs[0]?.trackType === "STATUTORY") && <FormattedMessage id="preCog.assetsTab.drawer.logs.capitalLossStatutory" />}
            {(filteredLogs[0]?.capital > 0 && filteredLogs[0]?.trackType === "TAX") && <FormattedMessage id="preCog.assetsTab.drawer.logs.capitalGainTax" />}
            {(filteredLogs[0]?.capital < 0 && filteredLogs[0]?.trackType === "TAX") && <FormattedMessage id="preCog.assetsTab.drawer.logs.capitalLossTax" />}
          </span>
          <p className="precog-assets-drawer-logs-info">{`${numeral(filteredLogs[0]?.capital).format("0,0.00")} €`}</p>
        </div>}
        {/* Will be added in the future
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.saleDepreciation" />
          </span>
          <p className="precog-assets-drawer-logs-info">XXXXXXX</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.nonDeductibilityPercentage" />
          </span>
          <p className="precog-assets-drawer-logs-info">XXXXXXX</p>
        </div> */}
      </div>
    </div>
  );
};

export default DisposalDrawerLogsDetails;